export const QUARTER_HEART = 0.25

export const HEART_STATE = Object.freeze({
  FULL: 'full',
  THREE_QUARTERS: 'three-quarters',
  HALF: 'half',
  QUARTER: 'quarter',
  EMPTY: 'empty'
})

export function normalizeHeartDamage(amount) {
  if (!Number.isFinite(amount) || amount <= 0) return 0
  return Math.max(QUARTER_HEART, Math.round(amount / QUARTER_HEART) * QUARTER_HEART)
}

export function normalizeHeartValue(value, maxHearts, fallback = 0) {
  const safeMax = Number.isFinite(maxHearts) ? Math.max(0, maxHearts) : Infinity
  const safeValue = Number.isFinite(value) ? value : fallback
  const snapped = Math.round(safeValue / QUARTER_HEART) * QUARTER_HEART
  return Math.min(safeMax, Math.max(0, snapped))
}

export function getHeartSlotState(currentHearts, slotIndex) {
  const quarterUnits = Math.round(Math.max(0, currentHearts) / QUARTER_HEART)
  const remainingUnits = quarterUnits - slotIndex * 4
  if (remainingUnits >= 4) return HEART_STATE.FULL
  if (remainingUnits === 3) return HEART_STATE.THREE_QUARTERS
  if (remainingUnits === 2) return HEART_STATE.HALF
  if (remainingUnits === 1) return HEART_STATE.QUARTER
  return HEART_STATE.EMPTY
}

export function describeHeartValue(value) {
  const normalized = normalizeHeartValue(value, Infinity)
  const whole = Math.floor(normalized)
  const fraction = normalized % 1
  const fractionNames = {
    0.25: 'a quarter',
    0.5: 'a half',
    0.75: 'three quarters'
  }
  const fractionName = fractionNames[fraction]

  if (whole === 0 && fractionName) return `${fractionName} of a heart`
  if (fractionName) return `${whole} and ${fractionName} hearts`
  return `${whole} ${whole === 1 ? 'heart' : 'hearts'}`
}
